// extracted by mini-css-extract-plugin
export var button = "_ca-4";
export var hasDarkBackground = "_ca-7";
export var hasLightBackground = "_ca-6";
export var iconWrapper = "_ca-0";
export var large = "_ca-2";
export var medium = "_ca-1";
export var small = "_ca-5";
export var xsmall = "_ca-3";